export const ENV_VARS_FIELD_KEYS = {
  list: 'envVars.list',
} as const;

export const ENV_VARS_FIELD_KEY_LIST = [ENV_VARS_FIELD_KEYS.list] as const;

export const ENV_VARS_ACTION_KEYS = {
  add: 'envVars.add',
  remove: 'envVars.remove',
} as const;

export const ENV_VARS_ACTION_KEY_LIST = Object.values(ENV_VARS_ACTION_KEYS);
